import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import {ResponsiveContainer,LineChart,CartesianGrid,XAxis,YAxis,Tooltip,Legend,Line,BarChart,Bar} from "recharts";
const cookies = new Cookies();


function Charts() {
    const navigate = useNavigate();
    document.body.style.backgroundColor = "#111b21";
    const [data, setData] = useState(null);
    const [groups, setGroups] = useState(null);

    useEffect(() => {
            const cookie = cookies.get('token');
            if (!cookie) navigate("../unauthorize", { replace: true });
            axios.get("https://newchatapp-mn65.onrender.com/chart", {
                headers: {
                    Authorization: 'Bearer ' + cookie
                }
            }).then((res) => {
                setData(res.data);
            })

            axios.get("https://newchatapp-mn65.onrender.com/mygroups", {
                headers: {
                    Authorization: 'Bearer ' + cookie
                }
            }).then((res) => {
                console.log(res.data);
                setGroups(res.data);
            })

    }, [])


  return (
    <div className='chart'>
        <h1>Charts</h1>
        {groups!==null && <><h3>My Groups</h3>
        <ResponsiveContainer width="100%" aspect={3}>
        <BarChart width={730} height={250} margin={{top:50,right:35,left:5,bottom:20}} data={groups} className="barchart">
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis interval={'preserveStartEnd'} dataKey="firstname" />
        <YAxis />
        <Tooltip contentStyle={{backgroundColor:"#F0FFFF"}} />
        <Legend />
        <Bar dataKey="messages" fill="#82ca9d" />
        </BarChart>
        </ResponsiveContainer></>}

        {data !==null && <><h3 style={{marginTop:"8rem"}}>Users</h3>
        <ResponsiveContainer width="100%" aspect={3} >
        <LineChart width={730} height={250} margin={{top:50,right:35,left:5,bottom:20}} data={data} className="linechart" >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis interval={'preserveStartEnd'} dataKey="firstname" />
        <YAxis />
        <Tooltip contentStyle={{backgroundColor:"#F0FFFF"}} />
        <Legend />
        <Line activeDot={{r:6}} type="monotone" dataKey="messages" stroke="#8884d8" />
        </LineChart>
        </ResponsiveContainer></>}

    </div>
  )
}

export default Charts